import type { RequestOperationalStatusDetail } from '../utils/hooks/useGetRequestOperationalStatus'

type Generation = Pick<RequestOperationalStatusDetail, 'status' | 'nextGenerationAt'>

// Activity schedules a run for the next minute; deadline events and failure retries land about an hour out.
const IMMINENT_MS = 10 * 60_000

// A claimed run clears the schedule, so PENDING with no slot is a refresh in flight, not one waiting on activity.
export const isSummaryRefreshing = ({ status, nextGenerationAt }: Generation, now: number): boolean => {
  const at = nextGenerationAt ? new Date(nextGenerationAt) : null
  if (at && !Number.isNaN(at.getTime())) return at.getTime() - now <= IMMINENT_MS
  return status === 'PENDING'
}
